import { useTranslations } from '@vocab/react';
import { Box, Stack, Text } from 'braid-design-system';
import { forwardRef, useMemo, type ComponentProps } from 'react';

import translations from '../.vocab';
import { useCareerFeedAIAssistant } from '../hooks/useCareerFeedAIAssistant';

import * as styles from './CareerFeedAIAssistantWidgetContainer.css';

const useWidgetHeading = () => {
  const { progress } = useCareerFeedAIAssistant();
  const { t } = useTranslations(translations);

  return useMemo(() => {
    switch (progress) {
      case 'initial':
      case 'gatheringRefinement':
      case 'collectGeneralRequirementsAtLast':
        return t('Want better job matches?');
      case 'recsRefined':
      case 'recsRefined-withPersistedData':
        return t('Refined for you');
    }
  }, [progress, t]);
};

interface CareerFeedAIAssistantWidgetContainerProps {
  showHeading?: boolean;
  children: ComponentProps<typeof Stack>['children'];
}
export const CareerFeedAIAssistantWidgetContainer = forwardRef<
  HTMLDivElement,
  CareerFeedAIAssistantWidgetContainerProps
>(({ showHeading, children }, ref) => {
  const headingText = useWidgetHeading();

  return (
    <Box
      display="flex"
      flexDirection="column"
      width="full"
      padding="medium"
      className={styles.indent}
      ref={ref}
    >
      <Stack space="xsmall">
        {showHeading && (
          <Text size="large" weight="medium">
            {headingText}
          </Text>
        )}
        {children}
      </Stack>
    </Box>
  );
});
